import {Component, Input, OnInit} from '@angular/core';
import {Button} from 'primeng/button';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {InputOtp} from 'primeng/inputotp';
import {interval, Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {LoginService} from '../../core/services/login-service/login.service';
import {AuthService} from '../../core/services/auth-service/auth.service';
import {Message, ResendOTPRequest, UserSession, VerifyOTPRequest} from '../../interfaces/loginInterface';

@Component({
  selector: 'app-two-fa',
  imports: [
    Button,
    FormsModule,
    InputOtp,
    ReactiveFormsModule
  ],
  standalone:true,
  providers: [LoginService,AuthService],
  templateUrl: './two-fa.component.html',
  styleUrl: './two-fa.component.scss'
})
export class TwoFaComponent implements OnInit {
  otpFormGroup: FormGroup | any;
  otpLoader: boolean = false;
  errorMessage = '';
  infoMessage = ''
  otpSent: boolean = false;
  username: string = '';
  timer: number = 60;
  resendLimitExceeded: boolean = false;
  isResendDisabled: boolean = true;
  timerSubscription !: Subscription;
  // userRequestId = localStorage.getItem('userRequestId');
  existingSession: any;
  sessions: { userEmail: string, sessionId: string }[] = []
  @Input() data!: ResendOTPRequest | null;

  constructor(
    private route: Router,
    private fb: FormBuilder,
    private loginService: LoginService,
    private authService: AuthService,
  ) {
    const navigation = this.route.getCurrentNavigation();
    this.username = navigation?.extras?.state?.['username'] || '';
    this.startResendTimer();
  }

  ngOnInit(): void {
    this.otpFormGroup = this.fb.group({otp: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]*$')]]});
    this.sessions = JSON.parse(localStorage.getItem('sessions') || '[]');
  }

  resendOtp(): void {
    this.resetResendTimer();
    const payload: ResendOTPRequest = {
      username: this.username,
      userRequestId: this.data?.userRequestId || '',
    };
    this.loginService.resendOTP(payload).subscribe({
      next: (res: any) => {
        if (res.message === Message.OTP_SENT) {
          this.otpSent = true;
          this.infoMessage = 'OTP Sent Successfully';
          setTimeout(() => this.otpSent = false, 10000);
        }
      },
      error: (err: any) => {
        if (err.error.code === 429) {
          this.resendLimitExceeded = true;
        }
        this.errorMessage = err ? err.error.reason : 'An error occurred. Please try again later.';
      },
    });
  }

  startResendTimer(): void {
    this.isResendDisabled = true;
    this.timer = 60;
    this.timerSubscription = interval(1000).subscribe(() => {
      this.timer--;
      if (this.timer === 0) {
        this.isResendDisabled = false;
        this.timerSubscription.unsubscribe();
      }
    });
  }

  resetResendTimer(): void {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.startResendTimer();
  }

  get otp() {
    return this.otpFormGroup.get('otp');
  }

  verifyOtp(): void {
    this.otpLoader = true;
    this.existingSession = this.sessions.find(
      (map: any) => map.userEmail === this.username
    );
    if (this.otpFormGroup.invalid) {
      this.otpLoader = false;
      if (this.otpFormGroup.get('otp')?.errors) {
        if (this.otpFormGroup.get('otp')?.errors?.required) {
          this.errorMessage = 'OTP is required.';
        } else if (this.otpFormGroup.get('otp')?.errors?.pattern) {
          this.errorMessage = 'Please enter a valid 8 digit OTP.';
        }
      }
      return;
    }
    this.errorMessage = '';
    const payload: VerifyOTPRequest = {
      otp: this.otpFormGroup.get('otp')?.value,
      userRequestId: this.data?.userRequestId || '',
      sessionId: this.existingSession?.sessionId
    };
    this.loginService.verifyOTP(payload).subscribe({
        next: (res:UserSession) => {
          this.authService.saveCredentials(res);
          this.route.navigate(['/dashboard']);
          // if (res.session_id) {
          //   if (!this.existingSession || this.existingSession?.sessionId !== res.sessionId) {
          //     this.sessions = this.sessions.filter(s => s.userEmail !== res.user_email)
          //     this.sessions.push({userEmail: res.user_email, sessionId: res.session_id});
          //     localStorage.setItem('sessions', JSON.stringify(this.sessions))
          //   }
          //   this.authService.saveCredentials(res);
          // } else {
          //   this.errorMessage = 'OTP is invalid';
          //   this.otpLoader = false;
          // }
        },
        error: (err: any) => {
          this.errorMessage = err ? err?.error?.reason : 'An error occurred. Please try again later.';
          this.otpLoader = false;
        },
      }
    )
  }

}
